<template>
  <section class="auth-form-container">
    <div class="auth-form-name">Reset your password</div>

    <div v-if="!reseted">
      <div class="mb-8 text-center">
        Almost done. Enter your new password, and your're good to go.
      </div>

      <div class="flex justify-end mb-4 mr-4 text-ricoma-gray-500">
        <span v-if="show" class="flex items-center h-5" @click="show = !show"
          ><VSvgIcon name="eye" class="w-full h-full"
        /></span>
        <span v-if="!show" class="flex items-center h-5" @click="show = !show"
          ><VSvgIcon name="eye-off" class="w-full h-full"
        /></span>
      </div>

      <form action="#" class="auth-form" @submit.prevent="handleResetPassword">
        <VFormInput
          :inputType="show ? 'text' : 'password'"
          label="Password"
          placeholder="New Password"
          :leftIcon="true"
          :error="errors.password"
          @update="val => handleInput('password', val)"
        >
          <template #left><VSvgIcon name="lock" /></template>
        </VFormInput>

        <VFormInput
          :inputType="show ? 'text' : 'password'"
          label="Confirm New Password"
          placeholder="Password"
          :leftIcon="true"
          :error="errors.password_confirmation"
          @update="val => handleInput('password_confirmation', val)"
        >
          <template #left><VSvgIcon name="lock" /></template>
        </VFormInput>

        <button class="auth-form-button" type="submit" :disabled="formLoading">
          <BeatLoader
            v-if="formLoading"
            color="#FAFAFA"
            :size="0.875"
            sizeUnit="rem"
            class="flex items-center"
          />
          <span v-else>reset password</span>
        </button>
      </form>
    </div>

    <div v-else class="auth-confirmation">
      <div class="auth-confirmation-box">
        <div class="auth-confirmation-box-content">
          <div class="px-3 font-bold"><VSvgIcon name="check-circle" /></div>
          <div>
            <div class="font-bold">Success!</div>
            <p>Your password has been updated.</p>
          </div>
        </div>
      </div>
      <router-link class="auth-form-button" to="/auth/login">Return to login</router-link>
    </div>
  </section>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';

import { launchNotification } from '@/utils';

import VSvgIcon from '@/components/base/VSvgIcon';
import VFormInput from '@/components/base/VFormInput';

import { formMixin } from '@/mixins';

export default {
  name: 'Reset',
  components: { VSvgIcon, VFormInput, BeatLoader },
  mixins: [formMixin({ password: '', password_confirmation: '' })],
  data() {
    return {
      email: '',
      token: '',
      reseted: false,
      show: false,
    };
  },
  methods: {
    handleInput(name, val) {
      this.handleResetError(name);
      this.handleSetField(name, val);
    },
    async handleResetPassword() {
      try {
        const submitted = await this.handleSubmit(data =>
          this.$http.post('password/reset', { ...data, token: this.token, email: this.email }),
        )();
        if (submitted) this.reseted = true;
      } catch (error) {
        this.formLoading = false;
        launchNotification(this, error);
      }
    },
  },
  mounted() {
    this.email = this.$route.query.email;
    this.token = this.$route.query.token;
  },
};
</script>
